<template>
  <div>
    <div class="view-container">
      <h2 class="view-title">
        Resources
      </h2>
      <ul>
        <li
          class="hor-list-item"
          @click="setResourceType('price-list')"
        >
          Whole Goods Price List
        </li>
      </ul>
    </div>
    <hr style="visibility:hidden">
  </div>
</template>

<script>
</script>

<style>
.view-container {
  position: fixed;
  top: 100px;
  border-left: 5px solid #0088ca;
  height: 75px;
  margin: 0;
  padding: 0;
  vertical-align: top;
  z-index: 1;
}
</style>